import './styles.scss';

import { DispatchIssueCausedByWithCache } from '@/models/gen/graphql';
import Popup from '@/common/Popup';
import { createComponentState } from '@/state';

type CausedByPopupState = {
  target: HTMLElement | string | null | undefined;
  causedBy: Array<DispatchIssueCausedByWithCache>;
};

export const initCausedByPopupState: CausedByPopupState = {
  target: undefined,
  causedBy: [],
};
export const useCausedByPopupState = createComponentState(initCausedByPopupState);

const CausedByPopover = () => {
  // init state
  const [target, causedBy] = useCausedByPopupState(({ state: { target, causedBy }, setState }) => [target, causedBy]);
  return (
    <Popup.Popover className="CausedByPopover" target={target} show={!!target} placement="top">
      <h5>Caused By</h5>
      <ul>
        {(causedBy || []).map(({ causedByFirstName: firstName, causedByLastName: lastName }) => {
          const name = `${firstName} ${lastName}`.trim();
          return <li key={name}>{name}</li>;
        })}
      </ul>
    </Popup.Popover>
  );
};

export default CausedByPopover;
